import { useMemo, forwardRef, useCallback } from 'react';
import { scrollFieldIntoView } from 'components/Fields/helpers';
import { getFieldAccessPermissions } from 'components/Fields/FieldInput/helpers';
import { getDisplayNameTooltipProps } from 'components/Inputs/inline/WithTooltip';

export const withCellWrapper = (Component) => {
  // return the Component wrapped with our cell wrapper

  return forwardRef((props, ref) => {
    const {
      value,
      entityId,
      entityAccess,
      field,
      column,
      onSubmit: onSubmitProp,
      showDisplayNameTooltip,
      forceReadOnly = false,
      supportsInfiniteScroll,
    } = props;

    // default fields handle setting up the patch
    const onSubmit = useCallback(
      async (value) => {
        const values = [{ field, value }];
        return onSubmitProp({ column, entityId, values });
      },
      [entityId, field, column, onSubmitProp]
    );

    const [editable, viewable] = useMemo(
      () => getFieldAccessPermissions(field, { access: entityAccess }),
      [field, entityAccess]
    );

    if (!viewable) {
      return null;
    }

    return (
      <Component
        ref={ref}
        {...props}
        value={value}
        field={field}
        onSubmit={onSubmit}
        readOnly={forceReadOnly || !editable || props.readOnly}
        editable={!forceReadOnly && editable}
        viewable={viewable}
        onAutoFocus={scrollFieldIntoView}
        supportsInfiniteScroll={supportsInfiniteScroll}
        {...getDisplayNameTooltipProps(showDisplayNameTooltip, field)}
      />
    );
  });
};

export const EMPTY_VALUE = '—';
